import styles from './Body.module.css';
import useViewportWidth from '../../hooks/useViewportWidth';
import { toggleCategoryExpandCollapse } from '../../../../../actions/gradebook';
import { useDispatch, useSelector } from 'react-redux';
import { getGradingType } from '../../utils';
import { noop } from 'lodash';
import CategoryNameButton from '../../../../CategoryNameButton/CategoryNameButton';
import { get } from 'lodash/fp';
import { GRADEBOOK_SETTINGS } from '@macmillan-learning/gradebook-shared';

export const Accordion = ({ children, categoryData }) => {
  const { collapsedCategoryIds, settings } = useSelector(get('gradebook'));
  const dispatch = useDispatch();
  const { isMobile } = useViewportWidth();

  const { assignments = [], id, total, name } = categoryData;
  const lowest =
    categoryData?.dropLowestNumGrades ||
    categoryData?.drop_lowest_num_grades ||
    total?.drop_lowest_num_grades;
  const weightVal = categoryData?.weight || categoryData?.total?.weight;

  const categoryId = id || assignments[0]?.gradebook_category_id;
  const isOpen = !collapsedCategoryIds.includes(categoryId);
  const gradingType = getGradingType(settings);

  const toggleOpen = (_e) => dispatch(toggleCategoryExpandCollapse(categoryId));

  return (
    <div className={styles.accordion}>
      <div
        className={styles.accordionButton}
        onClick={toggleOpen}
        data-test-id="individual-student-gb-collapse-gradebook-category"
        role="button"
      >
        <CategoryNameButton
          showWeightLabel={
            gradingType === GRADEBOOK_SETTINGS.gradingTypeWeighted
          }
          testId={'inidividual-student-gb-category-label'}
          category={{
            drop_lowest_num_grades: lowest,
            name,
            weight: weightVal,
          }}
          categoryNameClassName={styles.categoryName}
          active={isOpen}
          activeIcon="chevron_down"
          inactiveIcon="chevron_right"
          handleCategoryTabToggle={noop}
        />
        {isMobile && <div className={styles.scoreHeader}>Score</div>}
      </div>
      {isOpen && assignments?.length > 0 && children}
    </div>
  );
};
